<ion-tabs>
  <ion-tab-bar id="app-tab-bar" slot="bottom">
    <ion-tab-button tab="explore" [disabled]="navigating">
      <ion-icon class="icon" color="primary" src="assets/images/icons/home.svg"></ion-icon>
      <ion-label>{{ 'TABS.EXPLORE' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="activity" [disabled]="navigating">
      <ion-icon class="icon" color="primary" src="assets/images/icons/calendar.svg"></ion-icon>
      <ion-label class="font-medium">{{ 'TABS.ACTIVITY' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button [disabled]="navigating" (click)="presentActionSheet()">
      <ion-icon class="icon" color="primary" src="assets/images/icons/plus-circle.svg"></ion-icon>
      <ion-label>{{ 'TABS.CREATE_EVENT.TITLE' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="message" [disabled]="navigating">
      <ion-icon class="icon" color="primary" src="assets/images/icons/message.svg"></ion-icon>
      <ion-label>{{ 'TABS.MESSAGES' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="profile" [disabled]="navigating">
      <ion-icon class="icon" color="primary" src="assets/images/icons/user.svg"></ion-icon>
      <ion-label>{{ 'TABS.PROFILE' | translate }}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
